export default "__VITE_ASSET__YN6BzlXK__"